import { useState } from "react";
import { Flex, Button, Text, Box, Checkbox, chakra } from "@chakra-ui/react";
import Image from "next/image";

// Types
interface WalletDetails {
  connect: () => void;
  key: string;
  label: string;
  icon?: any;
}

interface WalletConnectModalBodyProps {
  walletMenuOptions: WalletDetails[];
  toggle: () => void;
  termAccepted: boolean;
}

export const WalletConnectModalBody = ({
  walletMenuOptions,
  toggle,
  termAccepted,
}: WalletConnectModalBodyProps) => {
  return (
    <>
      <Box
        bg="brand.textBg"
        px="1rem"
        marginBottom="1rem"
        borderRadius="0.5rem"
      >
        <Checkbox
          onChange={toggle}
          checked={termAccepted}
          defaultChecked={termAccepted}
        >
          <Text fontSize="12px">
            I have read and accept{" "}
            <chakra.a
              color="brand.primary"
              textDecoration="underline"
              textDecorationStyle="dotted"
              textUnderlineOffset="4px"
              _hover={{
                textDecoration: "underline",
              }}
              fontWeight="500"
              href="https://staderlabs.com/terms-of-service"
              target="_blank"
              rel="nofollow"
            >
              Terms of Service
            </chakra.a>
            .
          </Text>
        </Checkbox>
      </Box>
      <Box
        pointerEvents={!termAccepted ? "none" : "inherit"}
        opacity={termAccepted ? "1" : "0.5"}
      >
        {walletMenuOptions?.map((wallet: WalletDetails) => {
          const { key, label, connect, icon } = wallet;

          return (
            <Box
              as={Button}
              key={key}
              bg="brand.textBg"
              onClick={() => connect()}
              width="100%"
              outline="none"
              p="1rem"
              h="48px"
              mb="1rem"
              _hover={{
                background: "brand.primary",
                color: "brand.textLight",
              }}
            >
              <Flex
                width="100%"
                gap="0.5rem"
                alignItems="center"
                justifyContent="center"
              >
                {icon && (
                  <Box
                    height="20px"
                    borderRadius="50%"
                    overflow="hidden"
                    bgColor="black"
                  >
                    <Image
                      src={icon}
                      alt={`${key} Logo`}
                      width="20px"
                      height="20px"
                    />
                  </Box>
                )}
                <Text fontSize="12px" lineHeight="16px" fontWeight="300">
                  {label}
                </Text>
              </Flex>
            </Box>
          );
        })}
      </Box>
    </>
  );
};

export default WalletConnectModalBody;
